import gql from 'graphql-tag';
import { PAYMENT_METHOD_FRAGMENT } from '../../payment-methods.api';

export type TogglePlan =
  GetPaymentMethodQuery['search']['plans']['plans'][number];

export const GET_PAYMENT_METHOD = gql`
  query GetPaymentMethod($id: Int!, $accountId: Int!) {
    paymentMethod(id: $id) {
      ...paymentMethodData
    }
    search {
      plans(
        filters: { accountId: $accountId, statuses: ["active"] }
        page: 0
        limit: 10
        sort: created_at
        order: ASC
      ) {
        count
        plans {
          id
          paymentMethodId
          displayName
        }
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;

export const GET_PLANS_COUNT_BY_METHOD = gql`
  query GetPlansCountByMethod($id: Int!, $accountId: Int!) {
    search {
      plans(
        filters: {
          accountId: $accountId
          statuses: ["active"]
          paymentMethodId: $id
        }
        page: 0
        limit: 10
      ) {
        count
      }
    }
  }
`;

export const GetPaymentMethodMock = ({ totalCount = 2 } = {}) => ({
  paymentMethod: {
    id: 3,
    expirationDate: '2022-01-01',
    source: 'Visa',
    type: 'credit_card',
    description: 'Visa 1234',
    __typename: 'PaymentMethod',
  },
  search: {
    plans: {
      count: totalCount,
      plans: [
        { id: 1, paymentMethodId: 3, displayName: 'home' },
        { id: 2, paymentMethodId: 1, displayName: 'apt' },
      ],
    },
  },
});

export const GetPlansCountByMethodMock = {
  search: {
    plans: {
      count: 5,
    },
  },
};
